import styled from 'styled-components'

/**
 * A button that looks like a link. Useful for when you just want to run JavaScript when a user clicks a link rather than directing them anywhere.
 * 
 * @author Alex Clary
 */
export default styled.button`
  background: none !important;
  border: none;
  padding: 0 !important;
  text-decoration: underline;
  cursor: pointer;
  color: #0071bc;
  font-weight: 400;
  margin-right: 0;
  &:hover {
    color: #0071bc;
  }
`